// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsBranches_container__RvlAM"};